import { render, staticRenderFns } from "./ed-content-section-controls.component.vue?vue&type=template&id=036827d1&scoped=true&"
import script from "./ed-content-section-controls.component.ts?vue&type=script&lang=ts&"
export * from "./ed-content-section-controls.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-content-section-controls.component.scss?vue&type=style&index=0&id=036827d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036827d1",
  null
  
)

export default component.exports